import { render } from "./NumberView.vue?vue&type=template&id=7b477444"
import script from "./NumberView.vue?vue&type=script&lang=js"
export * from "./NumberView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__